
// Idea taken from https://redux.js.org/recipes/structuring-reducers/refactoring-reducers-example#combining-reducers-by-slice
// Basically each entity (company, terminal etc.) is structured to under one reducer. So when there will be more reducers, those
// just will be added to initialState and slide reducer.

import {
    LOAD_OLDTERMINAL_REQUEST, 
    LOAD_OLDTERMINAL_SUCCESS, 
    LOAD_OLDTERMINAL_FAILURE, 
    LOAD_NEWTERMINAL_REQUEST, 
    LOAD_NEWTERMINAL_SUCCESS, 
    LOAD_NEWTERMINAL_FAILURE,
    SUBMIT_TERMINALSWITCH_REQUEST,
    SUBMIT_TERMINALSWITCH_SUCCESS,
    SUBMIT_TERMINALSWITCH_FAILURE,
    GO_NEXT_TERMINALSWITCH_STEP,
    GO_BACK_TERMINALSWITCH_STEP,
    GO_FIRST_TERMINALSWITCH_STEP,
    GO_TO_TERMINALSWITCH_STEP,
    RESET_TERMINALSWITCH,
    CHANGE_TERMINALSWITCH_MODE
} from '../actions/actionTypes';
import {createReducer, updateObject} from './reducerUtilities';


const initialState = {
    activeStepState: {
        activeStepNum: 0,
        activeStepMode: 0,
    },
    oldTerminal: {
        terminalData: null,
        isLoading: false,
        hasFailed: false,
        errorText: ""
    },
    newTerminal: {
        terminalData: null,
        isLoading: false,
        hasFailed: false,
        errorText: ""
    },
    submitState: {
        isSuccess: false,
        isLoading: false,
        hasFailed: false,
        errorText: ""
    }
};

// Slice reducer
export const terminalSwitchReducer = createReducer(initialState, {
    [LOAD_OLDTERMINAL_REQUEST] : loadOldTerminalRequest,
    [LOAD_OLDTERMINAL_SUCCESS] : loadOldTerminalSuccess,
    [LOAD_OLDTERMINAL_FAILURE] : loadOldTerminalFailure,
    [LOAD_NEWTERMINAL_REQUEST] : loadNewTerminalRequest,
    [LOAD_NEWTERMINAL_SUCCESS] : loadNewTerminalSuccess,
    [LOAD_NEWTERMINAL_FAILURE] : loadNewTerminalFailure,
    [SUBMIT_TERMINALSWITCH_REQUEST]: submitTerminalSwitchRequest,
    [SUBMIT_TERMINALSWITCH_SUCCESS]: submitTerminalSwitchSuccess,
    [SUBMIT_TERMINALSWITCH_FAILURE]: submitTerminalSwitchFailure,
    [GO_NEXT_TERMINALSWITCH_STEP]: goNextTerminalSwitchStep,
    [GO_BACK_TERMINALSWITCH_STEP]: goBackTerminalSwitchStep,
    [GO_FIRST_TERMINALSWITCH_STEP]: goFirstTerminalSwitchStep,
    [GO_TO_TERMINALSWITCH_STEP]: goToTerminalSwitchStep,
    [RESET_TERMINALSWITCH]: resetTerminalSwitch,
    [CHANGE_TERMINALSWITCH_MODE]: changeTerminalSwitchMode,
});


// -----------------------------------------------------------------------
// LOAD  OLD TERMINAL
// -----------------------------------------------------------------------

// Case reducer
function loadOldTerminalRequest(state, action) {
    return {...state, oldTerminal: updateObject(
        state.oldTerminal, { 
            isLoading: true 
    })};
}

// Case reducer
function loadOldTerminalSuccess(state, action) {   
    return {...state, oldTerminal: updateObject(
        state.oldTerminal, { 
            terminalData: action.payload.terminal, 
            isLoading: false, 
            hasFailed: false,
            errorText: "",
    })};
}

// Case reducer
function loadOldTerminalFailure(state, action) {
    return {...state, oldTerminal: updateObject(
        state.oldTerminal, { 
            terminalData: null, 
            isLoading: false, 
            hasFailed: true,
            errorText: action.payload.errorText
    })};
}


// -----------------------------------------------------------------------
// LOAD  NEW TERMINAL
// -----------------------------------------------------------------------

// Case reducer
function loadNewTerminalRequest(state, action) {
    return {...state, newTerminal: updateObject(
        state.newTerminal, { 
            isLoading: true 
    })};
}

// Case reducer
function loadNewTerminalSuccess(state, action) {   
    return {...state, newTerminal: updateObject(
        state.newTerminal, { 
            terminalData: action.payload.terminal, 
            isLoading: false, 
            hasFailed: false,
            errorText: "",
    })};
}

// Case reducer
function loadNewTerminalFailure(state, action) {
    return {...state, newTerminal: updateObject(
        state.newTerminal, { 
            terminalData: null, 
            isLoading: false, 
            hasFailed: true,
            errorText: action.payload
    })};
}

// -----------------------------------------------------------------------
// SUBMIT TERMINAL SWITCH
// -----------------------------------------------------------------------

// Case reducer
function submitTerminalSwitchRequest(state, action) {
    return {...state, submitState: updateObject(
        state.submitState, { 
            isLoading: true 
    })};
}

// Case reducer
function submitTerminalSwitchSuccess(state, action) {   
    return {...state, submitState: updateObject(
        state.submitState, { 
            isSuccess: true,
            isLoading: false, 
            hasFailed: false,
            errorText: "",
    })};
}

// Case reducer
function submitTerminalSwitchFailure(state, action) {
    return {...state, submitState: updateObject(
        state.submitState, { 
            isSuccess: false,
            isLoading: false, 
            hasFailed: true,
            errorText: action.payload.errorText
    })};
}

// -----------------------------------------------------------------------
// TERMINAL SWITCH STEPS
// -----------------------------------------------------------------------


// Case reducer
function goNextTerminalSwitchStep(state, action) {
    return {...state, activeStepState: updateObject(
        state.activeStepState, { 
            activeStepNum: action.payload.activeStepNum,
            activeStepMode: action.payload.activeStepMode,
    })};
}

// Case reducer
function goBackTerminalSwitchStep(state, action) {
    return {...state, activeStepState: updateObject(
        state.activeStepState, { 
            activeStepNum: action.payload.activeStepNum,
            activeStepMode: action.payload.activeStepMode,
    })};
}

// Case reducer
function goFirstTerminalSwitchStep(state, action) {
    return {...state, activeStepState: updateObject(
        state.activeStepState, { 
            activeStepNum: action.payload.activeStepNum,
            activeStepMode: action.payload.activeStepMode,
    })};
}

// Case reducer
function goToTerminalSwitchStep(state, action) {
    return {...state, activeStepState: updateObject(
        state.activeStepState, { 
            activeStepNum: action.payload.activeStepNum,
            activeStepMode: action.payload.activeStepMode,
    })};
}

// Case reducer
function changeTerminalSwitchMode(state, action) {
    return {...state, activeStepState: updateObject(
        state.activeStepState, { 
            activeStepNum: action.payload.activeStepNum,
            activeStepMode: action.payload.activeStepMode,
    })};
}

// Case reducer
function resetTerminalSwitch(state, action) {
    return initialState;
}




// WEBPACK FOOTER //
// ./src/reducers/terminalSwitchReducer.js